import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function EnterSoloMultipleValuePlaceholder({ label }) {
    const { t } = useTranslation()
    return (
        <Box display="flex" alignItems="center" justifyContent="center">
            <Typography sx={{mx: 1}}>{t(label)}</Typography>
            {'('}
            <Typography variant="caption">
                {t("Press")}
                <kbd
                    style={{
                        border: "1px solid #aaa",
                        borderRadius: "0.2em",
                        boxShadow: "0.1em 0.1em 0.2em rgb(0 0 0 / 10 %)",
                        backgroundColor: "#f9f9f9",
                        backgroundImage: "linear - gradient(to bottom, #eee, #f9f9f9, #eee)",
                        color: "#000",
                        padding: 1,
                        fontFamily: "inherit",
                        fontSize: "0.65em",
                        marginLeft: 2,
                        marginRight: 2,
                    }}>↵ Enter</kbd >
                {t("after write text")}
            </Typography>
            {')'}
        </Box>
    )
}